import { createAsyncThunk } from "@reduxjs/toolkit";
import * as API from "./api";

// get StockAnalysis
export const getStockAnalysis = createAsyncThunk(
  "stockAnalysis/getStockAnalysis",
  async (params, { rejectWithValue }) => {
    const { rowsPerPage, search, sortOrder, pageNo, branch, product } = params;
    try {
      const { data } = await API.getStockAnalysis({
        rowsPerPage: rowsPerPage,
        search,
        sortOrder,
        pageNo,
        branch,
        product,
      });
      return data;
    } catch (error) {
      return rejectWithValue(error?.response?.data?.message);
    }
  }
);

// get all StockAnalysis
export const getAllStockAnalysis = createAsyncThunk(
  "stockAnalysis/getAllStockAnalysis",
  async (_, { rejectWithValue }) => {
    try {
      const { data } = await API.getAllStockAnalysis();
      return data;
    } catch (error) {
      return rejectWithValue(error?.response?.data?.message);
    }
  }
);

// get previous
export const getPrevious = createAsyncThunk("stockAnalysis/getPrevious", async (previous, { rejectWithValue }) => {
  try {
    const { data } = await API.getPrevious(previous);
    return data;
  } catch (error) {
    return rejectWithValue(error?.response?.data?.message);
  }
});
// get next
export const getNext = createAsyncThunk("stockAnalysis/getNext", async (next, { rejectWithValue }) => {
  try {
    const { data } = await API.getNext(next);

    return data;
  } catch (error) {
    return rejectWithValue(error?.response?.data?.message);
  }
});

// get particular page
export const getParticularPage = createAsyncThunk(
  "stockAnalysis/getParticularPage",
  async (params, { rejectWithValue }) => {
    const { number, rowsPerPage, search } = params;

    try {
      const { data } = await API.getPageStockAnalysis({ number, rowsPerPage: rowsPerPage, search });
      return data;
    } catch (error) {
      return rejectWithValue(error?.response?.data?.message);
    }
  }
);

// get StockAnalysis by item
export const getStockAnalysisByItem = createAsyncThunk(
  "stockAnalysis/getStockAnalysisByItem",
  async (id, { rejectWithValue }) => {
    try {
      const { data } = await API.getStockAnalysisByItem(id);
      return data;
    } catch (error) {
      return rejectWithValue(error?.response?.data?.message);
    }
  }
);

// handle search
export const handleSearch = createAsyncThunk("stockAnalysis/handleSearch", async (data, { rejectWithValue }) => {
  const { search, rowsPerPage } = data;
  try {
    const { data } = await API.handleSearch(search, rowsPerPage);
    return data;
  } catch (error) {
    return rejectWithValue(error?.response?.data?.message);
  }
});
